export function isBookingDetailsStepValid({
    treatment,
    appoinmentDate,
    bookedWith,
    assignToState,
} = {}) {
    const hasTreatment = !!(treatment && String(treatment).trim().length > 0);
    const hasDate = !!appoinmentDate;
    const hasBookedWith = (assignToState?.length || 0) >= 1
        || (Array.isArray(bookedWith) && bookedWith.length >= 1);

    return hasTreatment && hasDate && hasBookedWith;
}
